export default "__VITE_ASSET__9NvplQCs__"